import React from "react";
import useGoogleTranslate from "../../../hooks/useGoogleTranslate";

export default function GoogleTranslate() {
  useGoogleTranslate();
  return <div id="google_translate_element" style={{ width: 152 }}></div>;
}
